import { number, string, oneOfType } from "prop-types"

export const cssSize = oneOfType([
    string,
    number,
])
